module.exports = __webpack_public_path__ + "static/img/morningShift.03ba2100.svg";